const config = {
  env: process.env.NODE_ENV,
  baseUrl: process.env.REACT_APP_BASE_URL,
  aws_bucket: process.env.REACT_APP_AWS_BUCKET,
  userId_encryption_key: process.env.REACT_APP_ENCRYPT_KEY,
};

export default config;
